module.exports = __webpack_public_path__ + "static/logo-aee0b2e304d222126ed193348e443f00.svg";